if (!customElements.get('media-gallery')) {
	customElements.define(
		'media-gallery',
		class MediaGallery extends HTMLElement {
			constructor() {
				super();
				this.elements = {
					liveRegion: this.querySelector('[id^="GalleryStatus"]'),
					viewer: this.querySelector('[id^="GalleryViewer"]'),
					thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
				};
				this.mql = window.matchMedia('(min-width: 750px)');
				this.initSwipeNavigation();

				this.querySelectorAll('[data-js-sound-toggle]').forEach(buttonElement => {
					const containerElement = buttonElement.parentElement;
					const previewVideoElement = containerElement.querySelector('[data-js-preview-video]');
					const deferredMediaElement = containerElement.querySelector('[data-js-deferred-media]');

					buttonElement.addEventListener('click', async () => {
						const deferredVisible = deferredMediaElement.getClientRects().length > 0;
						if (deferredVisible && !deferredMediaElement.hasAttribute('loaded')) deferredMediaElement.loadContent(false);

						const videoElement = deferredVisible ? deferredMediaElement.lastElementChild : previewVideoElement;
						if (!deferredVisible && !videoElement.currentSrc) {
						videoElement.firstElementChild.src = videoElement.firstElementChild.dataset.src;
						videoElement.load();
						}

						videoElement.muted = !videoElement.muted;
						if (!videoElement.muted) {
						try { await videoElement.play(); } catch { videoElement.muted = true; }
						}

						buttonElement.setAttribute('aria-pressed', String(!videoElement.muted));
						buttonElement.setAttribute('aria-label', videoElement.muted ? buttonElement.dataset.enableSoundLabel : buttonElement.dataset.disableSoundLabel);
					});
				});

				if (!this.elements.thumbnails) return;

				this.elements.viewer.addEventListener(
					'slideChanged',
					debounce(this.onSlideChanged.bind(this), 500),
				);
				this.elements.thumbnails
					.querySelectorAll('[data-target]')
					.forEach(mediaToSwitch => {
						mediaToSwitch
							.querySelector('button')
							.addEventListener(
								'click',
								this.setActiveMedia.bind(
									this,
									mediaToSwitch.dataset.target,
									false,
								),
							);
					});
				if (
					this.dataset.desktopLayout.includes('thumbnail') &&
					this.mql.matches
				)
					this.removeListSemantic();
			}

			onSlideChanged(event) {
				const thumbnail = this.elements.thumbnails.querySelector(
					`[data-target="${event.detail.currentElement.dataset.mediaId}"]`,
				);
				this.setActiveThumbnail(thumbnail);
			}

			setActiveMedia(mediaId, prepend) {
				const activeMedia = this.elements.viewer.querySelector(
					`[data-media-id="${mediaId}"]`,
				);
				this.elements.viewer
					.querySelectorAll('[data-media-id]')
					.forEach(element => {
						element.classList.remove('is-active');
					});
				activeMedia.classList.add('is-active');

				if (prepend) {
					activeMedia.parentElement.prepend(activeMedia);
					if (this.elements.thumbnails) {
						const activeThumbnail = this.elements.thumbnails.querySelector(
							`[data-target="${mediaId}"]`,
						);
						activeThumbnail.parentElement.prepend(activeThumbnail);
					}
					if (this.elements.viewer.slider) this.elements.viewer.resetPages();
				}

				this.preventStickyHeader();
				window.setTimeout(() => {
					if (this.elements.thumbnails) {
						activeMedia.parentElement.scrollTo({
							left: activeMedia.offsetLeft,
						});
					}
					if (
						!this.elements.thumbnails ||
						this.dataset.desktopLayout === 'stacked'
					) {
						activeMedia.scrollIntoView({ behavior: 'smooth' });
					}
				});
				this.playActiveMedia(activeMedia);

				if (!this.elements.thumbnails) return;
				const activeThumbnail = this.elements.thumbnails.querySelector(
					`[data-target="${mediaId}"]`,
				);
				this.setActiveThumbnail(activeThumbnail);
				this.announceLiveRegion(
					activeMedia,
					activeThumbnail.dataset.mediaPosition,
				);
			}

			setActiveThumbnail(thumbnail) {
				if (!this.elements.thumbnails || !thumbnail) return;

				this.elements.thumbnails
					.querySelectorAll('button')
					.forEach(element => element.removeAttribute('aria-current'));
				thumbnail.querySelector('button').setAttribute('aria-current', true);
				if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

				this.elements.thumbnails.slider.scrollTo({
					left: thumbnail.offsetLeft,
				});
			}

			announceLiveRegion(activeItem, position) {
				const image = activeItem.querySelector(
					'.product__modal-opener--image img',
				);
				if (!image) return;
				image.onload = () => {
					this.elements.liveRegion.setAttribute('aria-hidden', false);
					this.elements.liveRegion.innerHTML =
						window.accessibilityStrings.imageAvailable.replace(
							'[index]',
							position,
						);
					setTimeout(() => {
						this.elements.liveRegion.setAttribute('aria-hidden', true);
					}, 2000);
				};
				image.src = image.src;
			}

			playActiveMedia(activeItem) {
				window.pauseAllMedia();
				const deferredMedia = activeItem.querySelector('.deferred-media');
				if (deferredMedia) deferredMedia.loadContent(false);
			}

			preventStickyHeader() {
				this.stickyHeader =
					this.stickyHeader || document.querySelector('sticky-header');
				if (!this.stickyHeader) return;
				this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
			}

			removeListSemantic() {
				if (!this.elements.viewer.slider) return;
				this.elements.viewer.slider.setAttribute('role', 'presentation');
				this.elements.viewer.sliderItems.forEach(slide =>
					slide.setAttribute('role', 'presentation'),
				);
			}

			initSwipeNavigation() {
				const slider = this.elements.viewer?.slider;
				if (!slider) return;

				const hasTouchInput =
					window.matchMedia('(pointer: coarse)').matches ||
					navigator.maxTouchPoints > 0;
				if (hasTouchInput) return;

				let pointerStartX = null;
				let pointerStartY = null;
				let pointerEndX = null;
				let pointerEndY = null;
				const swipeThreshold = 14;
				let isPointerDown = false;

				slider.querySelectorAll('img').forEach(image => {
					image.setAttribute('draggable', 'false');
				});
				slider.addEventListener('dragstart', event => event.preventDefault());

				slider.addEventListener('pointerdown', event => {
					if (event.pointerType !== 'mouse' && event.pointerType !== 'pen')
						return;
					isPointerDown = true;
					pointerStartX = event.clientX;
					pointerStartY = event.clientY;
					pointerEndX = pointerStartX;
					pointerEndY = pointerStartY;
				});

				slider.addEventListener('pointermove', event => {
					if (!isPointerDown) return;
					pointerEndX = event.clientX;
					pointerEndY = event.clientY;
				});

				slider.addEventListener('pointerup', event => {
					if (
						(event.pointerType !== 'mouse' && event.pointerType !== 'pen') ||
						pointerStartX === null ||
						pointerStartY === null
					)
						return;

					this.handleSwipe(
						(pointerEndX ?? event.clientX) - pointerStartX,
						(pointerEndY ?? event.clientY) - pointerStartY,
						swipeThreshold,
					);

					isPointerDown = false;
					pointerStartX = null;
					pointerStartY = null;
					pointerEndX = null;
					pointerEndY = null;
				});

				slider.addEventListener('pointercancel', () => {
					isPointerDown = false;
					pointerStartX = null;
					pointerStartY = null;
					pointerEndX = null;
					pointerEndY = null;
				});

				slider.addEventListener('pointerleave', () => {
					if (!isPointerDown) return;
					isPointerDown = false;
					pointerStartX = null;
					pointerStartY = null;
					pointerEndX = null;
					pointerEndY = null;
				});
			}

			handleSwipe(deltaX, deltaY, swipeThreshold) {
				const isHorizontalSwipe =
					Math.abs(deltaX) > swipeThreshold &&
					Math.abs(deltaX) > Math.abs(deltaY);
				if (!isHorizontalSwipe) return;

				if (deltaX < 0) {
					this.elements.viewer.nextButton?.click();
					return;
				}
				this.elements.viewer.prevButton?.click();
			}
		},
	);
}
